import { useState } from 'react';
import { View, Text } from 'react-native';
import theme from '../../theme';
import Nav from './Nav';
import Hero from './Hero';
import { HowItWorks } from './HowItWorks';
import {Faq} from './Faq';
import { CTA } from './CTA';
import { Footer } from './Footer';

const Agents = (props) => {

  const [responseStatus, setResponseStatus] = useState(null);

  const faqData = [
  { q: 'Does it write to my tables?', a: 'No — the agent runs read-only queries against BigQuery. It never inserts, updates, or deletes data.' },
  { q: 'Which warehouses are supported?', a: 'BigQuery today. AWS, Snowflake and Postgres are on the roadmap.' },
  { q: 'How is access controlled?', a: 'The agent inherits your existing BigQuery IAM permissions — it can only see what the connected service account can see.' },
  { q: 'Is setup complicated?', a: 'No — we can host and configure the agents / datasets for you. Alternatively, we can configure in your GCP.' },
];

  async function submitHandler(formData) {
  const API_URL = "https://bx9x6sd0rf.execute-api.eu-central-1.amazonaws.com/prod/form_submit";

  try {
    const response = await fetch(API_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        name: formData.name,
        email: formData.email,
        title: formData.jobTitle,
        company: formData.company,
        website: "", // honeypot — must stay empty, real users never see/fill this
      }),
    });

    const data = await response.json();
    setResponseStatus(response.status);
    return data;
    } catch (err) {
      setResponseStatus(0)
      throw err;
    }
  }


    return (
    <View style={{ width: '100%', backgroundColor: theme.colors.surfacePage }}>

      <Nav/>
      <Section style={{ borderBottomWidth: 1, borderBottomColor: theme.colors.borderDefault }} />

      <Hero submitHandler={submitHandler} responseStatus={responseStatus} />
      <Section />

      <HowItWorks/>
      <Section style={{ borderTopWidth: 1, borderTopColor: theme.colors.borderSubtle }} />

      <Faq
        data={faqData}
        header="FAQ"
      />
      <Section style={{ borderTopWidth: 1, borderTopColor: theme.colors.borderSubtle }} />

      <CTA 
        submitHandler={submitHandler}
        responseStatus={responseStatus}
        heading="Your data already knows the answer. Just ask."
        buttonLabel="Book a Demo"
      />
      <Section style={{ backgroundColor: theme.colors.gray950 }} />

      <Footer/>
      <Section style={{ borderTopWidth: 1, borderTopColor: theme.colors.borderDefault }} />

    </View>
  );

}

const Section = ({ style, children }) => (
    <View style={[{ width: '100%' }, style]}>{children}</View>
    );

export default Agents